var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c("div", { staticClass: "input-range-wrapp" }, [
        _c("div", { staticClass: "flex items-center mb-2" }, [
          _c("label", { attrs: { for: _vm.returnName } }, [
            _c("span", [
              _c("span", { staticClass: "opacity-50" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _vm._v(" "),
              _vm.required
                ? _c("span", { staticClass: "text-red text-lg leading-none" }, [
                    _vm._v("*"),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "text-[0px]",
              attrs: { for: _vm.returnName + "-range" },
            },
            [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]
          ),
          _vm._v(" "),
          _vm.tooltip
            ? _c("span", { staticClass: "tooltip top" }, [
                _c(
                  "button",
                  {
                    staticClass: "tooltip-icon",
                    attrs: { type: "button", "aria-label": "info" },
                  },
                  [
                    _c("svg", { staticClass: "w-[6px] h-2" }, [
                      _c("use", { attrs: { "xlink:href": "#icon-question" } }),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "tooltip-arrow" }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "tooltip-popup" }, [
                  _vm._v("\n          " + _vm._s(_vm.tooltip) + "\n        "),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "relative flex h-16 md:h-[72px]" }, [
          _c("div", { staticClass: "relative w-full h-full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueWithMask,
                  expression: "valueWithMask",
                },
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.mask,
                  expression: "mask",
                },
              ],
              staticClass:
                "block h-full w-full text-base text-blue font-medium px-8 input-border focus-visible:border-blue !outline-none duration-200",
              attrs: {
                type: "text",
                id: _vm.returnName,
                name: _vm.returnName,
                placeholder: " ",
                autocomplete: "off",
              },
              domProps: { value: _vm.valueWithMask },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.valueWithMask = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              ref: "range",
              staticClass:
                "block absolute bottom-0 h-px mx-[3px] outline-none w-full",
              attrs: {
                type: "range",
                id: _vm.returnName + "-range",
                min: 0,
                max: _vm.numSteps,
              },
              domProps: { value: _vm.rangeValue },
              on: { input: _vm.handleRangeInput },
            }),
          ]),
          _vm._v(" "),
          _vm.sideTag
            ? _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center h-full px-6 bg-gray pointer-events-none",
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-base text-blue/50 whitespace-nowrap" },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.sideTag) + "\n        "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }